import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from "store/index";
import { IUser } from "../interfaces/IUser";

export interface UserState {
  value: IUser,
}

// const testUser = isInDev && environment.useTestUser ? environment.testUser : null;

const initialState: UserState = {
  value: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state: UserState, action: PayloadAction<any>) => {
      state.value = action.payload;
    }
  }
});

export const { setUser } = userSlice.actions;

export const userReducer = (state: RootState) => state.user;

export default userSlice.reducer;
